import { PAGES } from "@dune/types";
import { FormProvider } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useAddMaterialParticipantToReception } from "../../../../api/mutations/constructionSiteSubmission.mutations";
import { MaterialToReceptionForm } from "../../../../component/constructionSites/submission/participants/MaterialToReceptionForm";
import PageLayoutWithTabs from "../../../../component/layout/PageLayoutWithTabs";
import { useMaterialToReceptionForm } from "./useParticipantToReceptionForm";

const AddMaterialReceptionPage = () => {
	const navigate = useNavigate();
	const { constructionSiteId } = useParams<{ constructionSiteId: string }>();

	function goBack() {
		if (constructionSiteId)
			navigate(PAGES.PROJECTS.reception.withParams(constructionSiteId, 3));
	}

	const numericConstructionSiteId = constructionSiteId
		? Number(constructionSiteId)
		: 0;

	const addMaterial = useAddMaterialParticipantToReception(
		numericConstructionSiteId,
	);

	const formApi = useMaterialToReceptionForm({
		mode: "add",
		onSubmit: (data) => addMaterial.mutate(data, { onSuccess: () => goBack() }),
	});

	if (!constructionSiteId) return null;

	return (
		<PageLayoutWithTabs title="Ajouter un matériau">
			<FormProvider {...formApi.form}>
				<form onSubmit={formApi.handleSubmit}>
					<MaterialToReceptionForm
						constructionSiteId={numericConstructionSiteId}
						onSubmit={formApi.handleSubmit}
						onCancel={goBack}
						isSubmitting={addMaterial.isPending}
					/>
				</form>
			</FormProvider>
		</PageLayoutWithTabs>
	);
};

export default AddMaterialReceptionPage;
